import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'jotai';
import HomePage from './pages/home';
import JobPage from './pages/job';
import TakeOffPage from './pages/take-off';
import SchedulePage from './pages/schedule';
import SitePlanPage from './pages/site-plan';
import NotFoundPage from './pages/not-found';
import Layout from './pages/_layout';
import { startAutoSync } from './lib/outbox';
import { whenSiteCrmKnown } from './lib/device-crm';
import { refreshReference } from './lib/reference';

export default function App() {
  // Sync whatever is waiting: now, when signal returns, and when the app comes back to the front.
  useEffect(() => startAutoSync(), []);
  // Copy the latest reference lists to the device while there's signal (opening or refreshing a job does
  // it too) — once /api/me has said which CRM this site uses, or the refresh would skip itself. The
  // effect's cleanup cancels the wait, so a second mount (StrictMode) doesn't refresh twice.
  useEffect(() => whenSiteCrmKnown(() => void refreshReference()), []);

  return (
    <Provider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="job/:jobId" element={<JobPage />} />
            <Route path="job/:jobId/take-off/:measureId" element={<TakeOffPage />} />
            <Route path="job/:jobId/schedule/:measureId" element={<SchedulePage />} />
            <Route path="job/:jobId/site-plan" element={<SitePlanPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}
